import { Directive, EventEmitter, Input, Output } from '@angular/core';

import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { RelatedToType } from '@shared/enums';
import { Account, FieldDef } from '@core/models';

export interface PanelDef<T> {
  id?: string;
  type: string;
  title: string;
  meta: T;
  color?: any;
}

export interface EditToggle<T> {
  toggle: boolean;
  panelDef: PanelDef<T>;
}

export interface PanelInterfaceComponent<T> {
  panelDef: PanelDef<T>;
  fieldDefs: FieldDef[];
  model: any;
  data: any;
  account?: Account;
  customObjectsOnly?: boolean;
  templateId?: number;
  relatedToType?: RelatedToType;
  panelDefUpdated: EventEmitter<PanelDef<T>>;
  silentPanelDefUpdated: EventEmitter<PanelDef<T>>;
  dataUpdated: EventEmitter<any>;
  editToggled: EventEmitter<EditToggle<T>>;
  readonly?: boolean;
  canEditLayout?: boolean;
  completeSaving?: () => void;
}

@Directive()
export class PanelComponentBase<T> extends OnDestroyMixin implements PanelInterfaceComponent<T> {
  @Input() panelDef: PanelDef<T>;
  @Input() fieldDefs: FieldDef[];
  @Input() model: any;
  @Input() data: any;
  @Input() readonly: boolean;
  @Input() canEditLayout: boolean;
  @Input() account: Account;
  @Input() relatedToType: RelatedToType;
  @Output() panelDefUpdated = new EventEmitter<PanelDef<T>>();
  @Output() silentPanelDefUpdated = new EventEmitter<PanelDef<T>>();
  @Output() dataUpdated = new EventEmitter<any>();
  @Output() editToggled = new EventEmitter<{ toggle: boolean; panelDef: PanelDef<T> }>();

  columnDefs: any[];
  panelDefMemento: PanelDef<T>;
  ui: {
    panelName: string;
    panelColor: any;
    editMode: boolean;
    changeTitleMode: boolean;
    titleFieldDef: any;
  };
  component: any;
}

export interface FormPanelMeta {
  fields: string[][];
}

export interface MatrixPanelMeta extends FormPanelMeta {
  columns: string[];
  footer?: string[];
  showFooter?: boolean;
}

export interface ChartPanelMeta {
  chartId?: number;
  activeTab?: string;
  startDate?: string;
  endDate?: string;
}
